import React from 'react';
const styles = require('./LjSpinner.module.scss');
const spinnerAnimation = require('./../../images/spinner_lj_2025.svg');

const LjSpinner = () => {
  return (
    <div className={styles.spinnerContainer}>
      <div className={styles.overlay}>
        <div className={styles.spinner}>
          <object type='image/svg+xml' data={spinnerAnimation} role='img' aria-label='Loading'>
            Loading…
          </object>
        </div>
      </div>
    </div>
  );
};

export default LjSpinner;
